/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { BaseEnum } from './base/BaseEnum';

export class EmailInvitationType extends BaseEnum {
  static AUTOMATIC_REGISTRATION = new EmailInvitationType('automatic-registration');

  static EXTERNAL_SIGN = new EmailInvitationType('external-sign');
}
